export default __webpack_public_path__ + "static/media/dreamfactory.59477293.svg";